export function suggestedContacts (state, newContacts) {
  state.suggestedContacts = newContacts
}
